import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';
import {match} from 'ts-pattern';

type CodeListOption = {label: string; value: string};

const getWarehouseSalesPriceCalculationOptionsResponseMock: CodeListOption[] = [
  {
    label: 'Margin (%) on base',
    value: 'MARGIN_ON_BASE',
  },
  {
    label: 'Markup (%) on base',
    value: 'MARKUP_ON_BASE',
  },
  {
    label: 'Profit on base',
    value: 'PROFIT_ON_BASE',
  },
  {
    label: 'Manual',
    value: 'MANUAL',
  },
  {
    label: 'Recommended price',
    value: 'RECOMMENDED_PRICE',
  },
  {
    label: 'Marketing code',
    value: 'MARKETING_CODE',
  },
];

const getWarehouseBaseSourcePriceOptionsResponseMock: CodeListOption[] = [
  {
    label: 'Average purchase price',
    value: 'AVG_PURCHASE',
  },
  {
    label: 'Last purchase price',
    value: 'LAST_PURCHASE',
  },
  {
    label: 'Recommended price',
    value: 'RECOMMENDED',
  },
  {
    label: 'Manual',
    value: 'MANUAL',
  },
];

const getCodeListOptionsResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/codelist*', ({request}) => {
      const url = new URL(request.url);
      const category = url.searchParams.get('category');

      return match(category)
        .with('WRH-SALES-PRICE-CALCULATION', () =>
          HttpResponse.json(getWarehouseSalesPriceCalculationOptionsResponseMock)
        )
        .with('WRH-SALES-PRICE-CALCULATION', () =>
          HttpResponse.json(getWarehouseSalesPriceCalculationOptionsResponseMock)
        )
        .otherwise(() => HttpResponse.json());
    })
  );

export const coreApiMock = {
  getWarehouseSalesPriceCalculationOptionsResponseMock,
  getWarehouseBaseSourcePriceOptionsResponseMock,
  getCodeListOptionsResponseInterceptor,
};
